import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal/Modal';
import DyCollectionCard from '../DyCollectionCard/DyCollectionCard';

import useDyRecommendationWidgetData from '../../hooks/useDyRecommendationWidget';

import { StyledH5, StyleFlexRow } from './ProductAddOnModalStyles';

var ProductAddOnModal = function ProductAddOnModal(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalActive = _useState2[0],
      setModalActive = _useState2[1];

  var sizeOption = props.selectedOptions && props.selectedOptions.size && props.selectedOptions.size;

  var dyData = useDyRecommendationWidgetData({
    dySlug: props.addOnModalTag,
    sizeOption: sizeOption,
    maxItems: 2
  });

  useEffect(function () {
    if (props.atcClicked === true) {
      setModalActive(true);
    }
  }, [props.atcClicked]);

  if (modalActive && dyData.items.length) {
    return React.createElement(
      Modal,
      {
        className: 'ProductAddOnModal',
        active: modalActive,
        closeModalFunc: function closeModalFunc() {
          return setModalActive(false);
        }
      },
      React.createElement(
        'div',
        {
          'data-dy-widget-id': dyData.widgetId,
          'data-dy-strategy-id': dyData.strategy,
          'data-dy-feed-id': dyData.feedId
        },
        React.createElement(
          StyledH5,
          null,
          dyData.title
        ),
        React.createElement(
          StyleFlexRow,
          null,
          dyData.items.map(function (item) {
            return React.createElement(DyCollectionCard, {
              key: item.item.sku,
              product: item.item,
              addVariantToCart: props.addVariantToCart,
              checkout: props.checkout,
              isAddOnModal: true
            });
          })
        )
      )
    );
  } else {
    return null;
  }
};

ProductAddOnModal.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  atcClicked: PropTypes.bool.isRequired,
  addOnModalTag: PropTypes.string.isRequired,
  selectedOptions: PropTypes.object
};

export default ProductAddOnModal;